type EventHandler<T = unknown> = (payload: T) => void;

export class Emitter<Events extends Record<string, unknown>> {
  private handlers: {
    [K in keyof Events]?: EventHandler<Events[K]>[];
  } = {};

  on<K extends keyof Events>(event: K, handler: EventHandler<Events[K]>) {
    if (!this.handlers[event]) {
      this.handlers[event] = [];
    }
    this.handlers[event]!.push(handler);
  }

  off<K extends keyof Events>(event: K, handler: EventHandler<Events[K]>) {
    if (!this.handlers[event]) return;
    this.handlers[event] = this.handlers[event].filter((h) => h !== handler);
  }

  emit<K extends keyof Events>(event: K, payload?: Events[K]) {
    if (!this.handlers[event]) return;
    this.handlers[event]!.forEach((h) => h(payload as Events[K]));
  }
}
